import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography } from "@mui/material";
import SuperadminAppCard from "./components/apps/SuperadminAppCard";
import { axios_superadmin } from "../../../axios";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import AddModal from "./components/apps/AddAppModal";

const SuperAdminAppList = () => {
    const initialState = {
        app_name: "",
        app_description: "",
        app_image_url: "",
        app_home_url: ""
    };

    const [appValues, setAppValues] = useState(initialState);
    const [openAdd, setOpenAdd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [imageString, setImageString] = useState("");

    const { app_name, app_description, app_image_url, app_home_url } = appValues;

    const { search } = useSelector(state => ({ ...state }));
    const { text } = search;

    const searched = keyword => c => c.app_name.toLowerCase().includes(keyword);

    const [appData, setAppData] = useState([]);
   
    const location = useLocation();
    let dispatch = useDispatch();

    useEffect(() => {
        getAppData();
    }, []);

    useEffect(() => {
        dispatch({
            type: "SEARCH_QUERY",
            payload: { text: "" }
        });
        getAppData();
    }, [location.pathname]);

    const getAppData = () => {
        axios_superadmin
            .get("/superAdmin/apps")
            .then(res => {
                setAppData(res.data);
            })
            .catch(err => {
            });
    };

    const handleAddClick = () => {
        setOpenAdd(!openAdd);
    };

    const convertToBase64 = async file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setImageString(reader.result);
        };
        
    };

    const handleFileChange = async e => {
        let file = e.target.files[0];

        try {
            await convertToBase64(file);
        } catch (error) {
        }
    };

    const handleAddChange = e => {
        setAppValues({ ...appValues, [e.target.id]: e.target.value });
    };

    const handleAddSubmit = async (app_name,app_description,app_home_url) => {
        setLoading(true);
        try {
            const response = await axios_superadmin.post(`/superAdmin/apps/add`, { app_name, app_description, app_image_url: imageString, app_home_url })
            getAppData();
            toast.success(response.data.message);
        } catch (error) {
        } finally {
            setLoading(false);
            setOpenAdd(false);
        }
       
    };

    const AddIconWrapper = styled("div")({
        position: "fixed",
        bottom: "10%",
        right: "5%"
    });

    const handleEditSubmit = async (id, appName, imageUrl) => {
        setLoading(true);
        try {
            const response = await axios_superadmin.post(`/superAdmin/apps/update/${id}`, { app_name: appName, app_image_url: imageUrl });
            getAppData();
            toast.success(response.data.message);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container>
            {appData.length === 0 ? (
                <Typography variant="h3" color="black">
                    {" "}
                    Loading...
                </Typography>
            ) : (
                <Grid container justifyContent="center" sx={{marginLeft: '15%', marginRight: '15%' }} >
                    {appData?.filter(searched(text.toLowerCase()))?.map((p, i) => (
                        <Grid item key={p.app_id} xs={12} sm={4} md={4} lg={4} style={{marginBottom:"3.5%"}}>  
                            <SuperadminAppCard p={p} handleEditSubmit={handleEditSubmit} loading={loading}/>
                        </Grid>
                    ))}
                </Grid>
            )}

            <AddIconWrapper>
                <AddIcon sx={{ fontSize: "4rem", margin: "3%", cursor: "pointer" }} onClick={handleAddClick} />
            </AddIconWrapper>
            <AddModal 
                openAdd = {openAdd}
                setOpenAdd = {setOpenAdd}
                handleFileChange = {handleFileChange}
                handleAddChange = {handleAddChange}
                handleAddSubmit = {handleAddSubmit}
                appName = {app_name}
                appDescription = {app_description}
                appHomeUrl = {app_home_url}
                loading={loading}
            />
        </Grid>
    );
};

export default SuperAdminAppList;
